import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

//token working
const login2 = (data) => {
  return apiRequestType(apiTypes.POST, apiConstants.LOGIN.LOGIN2, data);
};

export default login2;
